import React, { useState } from "react";
import { useEvent } from "@hooks/useEvent";
import { Text } from "@fragments";
import { VideoCallRounded } from "@mui/icons-material";
import {
    CommunityAssetImageField,
    AssetCategory,
} from "@features/uploadAsset";
import VideoUpload from "../components/VideoUpload";
import VideosUploadStatusBox from "../components/VideosUploadStatusBox";
import EVENTS from "../events";

export default function Video({
    sectionRef,
    communityId,
    bannerUrl,
    onBannerChange,
    onBannerUploadingChange,
    defaultAspectRatio,
    defaultVideoUrl,
    onVideoUploaded,
    onRemoveVideo,
    onGenerateThumb,
}) {
    const [aspectRatio, setAspectRatio] = useState(defaultAspectRatio || 1.78);
    const [videoUrl, setVideoUrl] = useState(defaultVideoUrl);

    useEvent(EVENTS.ASPECT_RATIO_CHANGE, (ratio) => {
        setAspectRatio(ratio);
    });

    useEvent(EVENTS.VIDEO_URL_CHANGE, (url) => {
        setVideoUrl(url);
    });

    return (
        <div ref={sectionRef} tabIndex={-1}>
            <Text.h3
                left={<VideoCallRounded />}
                value="Vídeo"
                className="mb-1 mt-4"
            />

            <div
                className="video-upload-area "
                style={{
                    width: aspectRatio > 1 ? "100%" : "fit-content",
                }}
            >
                <div className="banner-select-box">
                    {communityId ? (
                        <CommunityAssetImageField
                            communityId={communityId}
                            category={AssetCategory.CONTENT_BANNER}
                            value={bannerUrl}
                            onChange={onBannerChange}
                            onUploadingChange={onBannerUploadingChange}
                            size={aspectRatio > 1 ? 100 : 140}
                            aspectRatio={aspectRatio}
                            imageMaxWidth={1600}
                            title="Banner"
                            displayTitle
                        />
                    ) : null}
                </div>
                <VideoUpload
                    aspectRatio={aspectRatio}
                    handleRemoveVideo={onRemoveVideo}
                    url={videoUrl}
                    onSelected={onGenerateThumb}
                    onLoaded={onVideoUploaded}
                />
                <VideosUploadStatusBox />
            </div>
        </div>
    );
}
